import classNames from "classnames";
import styles from "./finecoButton.module.css";

type FinecoButtonProps = {
  click: () => void;
  copy: string;
  disabled?: boolean;
  white?: boolean;
};
export const FinecoButton: React.FC<FinecoButtonProps> = ({
  click,
  copy,
  disabled = false,
  white = false,
}) => {
  return (
    <div
      className={classNames(
        classNames(styles.button, white ? styles.whiteVariant : null),
        disabled ? styles.notAllowed : styles.allowed,
      )}
      style={{ width: "auto" }}
      onClick={disabled ? undefined : click}
    >
      {copy}
    </div>
  );
};
